export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/java.9c7516d.svg";